import {
  ApiLegacyCustomElementResponse,
  ApiTransitionElementResponse,
  ApiTransitionStoryGroupResponse,
} from '../../../../../../api/core/models';

export const isTransitionStoryGroup = (
  t: ApiTransitionElementResponse | ApiTransitionStoryGroupResponse | ApiLegacyCustomElementResponse
): t is ApiTransitionStoryGroupResponse => {
  const group = t as ApiTransitionStoryGroupResponse;
  return (
    group.transitionElements !== undefined ||
    group.legacyCustomElements !== undefined ||
    group.subTransitionStoryGroups !== undefined ||
    (group.transitionElements === undefined &&
      group.legacyCustomElements === undefined &&
      group.subTransitionStoryGroups === undefined &&
      (t as ApiTransitionElementResponse).transitionElement === undefined &&
      (t as ApiLegacyCustomElementResponse).data === undefined)
  );
};
